import { useState } from 'react';

export const usePartnerHandler = () => {
  const [filters, setFilters] = useState({});
  const [filterDefault, setFilterDefault] = useState(null);

  const handlePartnerSelection = (selectedOption) => {
    let sTemp = null;
    if (selectedOption) {
      sTemp = `[${selectedOption.value}][${selectedOption.label}]`;
    }
    setFilters((prev) => ({
      ...prev,
      arr: sTemp,
    }));
  };

  const handleSearchHistory = (data) => {
    if (!data) return;
    const sTemp = data.arr;
    if (typeof sTemp === 'string') {
      const matches = sTemp.match(/\[([^\]]+)\]/g);
      if (matches) {
        const extractedValues = matches.map((match) => match.slice(1, -1));
        setFilterDefault(extractedValues[1]);
      }
    }
  };

  return {
    filters,
    filterDefault,
    handlePartnerSelection,
    handleSearchHistory,
    setFilterDefault, // Optional: Expose this if needed
  };
};
